import {
  getNews,
  getNewDetail,
  getNewsTab,
  getAllNews
} from '../../apis/news';
import { NEWS } from '../mutation-types';

export const state = {
  newsAll: [],
  newDetail: [],
  pagePrevious: 1,
  tabPrevious: 0,
  allNews: [],
  isShowNewsIcon: false,
};

export const getters = {
  newsAll: state => state.newsAll,
  newDetail: state => state.newDetail,
  pagePrevious: state => state.pagePrevious,
  tabPrevious: state => state.tabPrevious,
  allNews: state => state.allNews,
  isShowNewsIcon: state => state.isShowNewsIcon,
};
export const mutations = {
  [NEWS.GET_NEWS](state, res) {
    if (!res.err) {
      const data = res.list;
      state.newsAll = data;
    }
  },
  [NEWS.GET_NEWS_DETAIL](state, res) {
    if (!res.err) {
      console.log(res);
      state.newDetail = res;
    }
  },
  [NEWS.GET_NEWS_TAB](state, res) {
    if (!res.err) {
      const data = res.list;
      state.newsAll = data;
    }
  },
  [NEWS.PAGE_PREVIOUS](state, res) {
    state.pagePrevious = res.page;
    state.tabPrevious = res.tab;
  },
  [NEWS.GET_ALL_NEWS](state, res) {
    if (!res.err) {
      const { data } = res.list;
      state.allNews = data;
    }
  },
  setNewIcon(state, data) {
    state.isShowNewsIcon = data;
  },
};
export const actions = {
  async getNews({ commit }, page) {
    const res = await getNews(page);
    commit(NEWS.GET_NEWS, res);
  },
  async getNewDetail({ commit }, id) {
    const res = await getNewDetail(id);
    commit(NEWS.GET_NEWS_DETAIL, res);
  },
  async getNewsTab({ commit }, payload) {
    const res = await getNewsTab(payload);
    commit(NEWS.GET_NEWS_TAB, res);
  },
  pagePrevious({ commit }, payload) {
    commit(NEWS.PAGE_PREVIOUS, payload);
  },
  async getAllNews({ commit }) {
    const res = await getAllNews();
    commit(NEWS.GET_ALL_NEWS, res);
  },
};
